// removed by extract-text-webpack-plugin
module.exports = {"container":"_2btFn3AzvkiYdFhIh1KqCC","splash":"R9N8hctchSOJ6iVukfNOp","auth":"_3Z9SG12gCDAMkJXm_dtM9v","header":"QuEELRM7ZOYbE8s2365zk","settings-view":"_2kJjM69wvHVWbAtqGwq65T"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/Splash.styl
// module id = 502
// module chunks = 0